import React from "react";

import { Inventory } from "../features/inventory/Inventory.tsx";
import { CurrencyFilter } from "../features/currencyFilter/CurrencyFilter.tsx";
import { Cart } from "../features/cart/Cart.tsx";
import { SearchTerm } from "../features/searchTerm/SearchTerm.tsx";
import { AppProps } from "../types/app";

export const App = ({ state, dispatch }: AppProps) => {
  const cartItemCount = Object.values(state.cart).reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <div id="app-shell">
      <header className="store-header">
        <div className="brand-lockup">
          <div className="brand-mark" aria-hidden="true">
            CS
          </div>
          <div>
            <p className="brand-eyebrow">Codecademy Store</p>
            <h1 className="brand-name">Compile Supply Co.</h1>
          </div>
        </div>

        <nav className="store-nav" aria-label="Primary navigation">
          <a href="#products">Shop</a>
          <a href="#cart-container">Cart</a>
          <a href="#store-footer">About</a>
        </nav>

        <a
          className="cart-pill"
          href="#cart-container"
          aria-label={`View cart with ${cartItemCount} item${
            cartItemCount === 1 ? "" : "s"
          }`}
        >
          <span className="cart-pill-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" role="img">
              <path d="M9 20a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm8 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM4 2h2l2.1 10.3A2 2 0 0 0 10 14h7.4a2 2 0 0 0 1.9-1.4L22 5H7.2" />
            </svg>
          </span>
          <span>Cart</span>
          <span className="cart-pill-count">{cartItemCount}</span>
        </a>
      </header>

      <section className="hero">
        <p className="hero-kicker">New Drop</p>
        <h2 className="hero-title">Gear for people who build products.</h2>
        <p className="hero-copy">
          Curated developer essentials, fast shipping, and global currency
          support.
        </p>
        <a className="hero-cta" href="#products">
          Browse Collection
        </a>
      </section>

      <main className="store-layout">
        <section className="catalog-column">
          <div className="catalog-toolbar">
            <SearchTerm searchTerm={state.searchTerm} dispatch={dispatch} />

            <CurrencyFilter
              currencyFilter={state.currencyFilter}
              dispatch={dispatch}
            />
          </div>

          <Inventory
            inventory={state.inventory}
            searchTerm={state.searchTerm}
            currencyFilter={state.currencyFilter}
            dispatch={dispatch}
          />
        </section>

        <aside className="cart-column">
          <Cart
            cart={state.cart}
            currencyFilter={state.currencyFilter}
            dispatch={dispatch}
          />
        </aside>
      </main>

      <footer id="store-footer" className="store-footer">
        <p>Compile Supply Co. | Built for developers, designed for everyday.</p>
      </footer>
    </div>
  );
};
